/* Stroomkaart - translations: common (nav, footer, shared CTAs)
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ----- Common: navigatie, footer, gedeelde CTA's ----- */
  common: {
    nav: {
      requesters:     'Aanvragers',
      owners:         'Eigenaren',
      types:          'Type stroomvoorzieningen',
      about_contact:  'Over & Contact',
      login:          'Inloggen',
      open_map:       'Open de kaart',
      contact_cta:    'Neem contact op',
      menu_open:      'Menu openen',
      mobile_label:   'Mobiele navigatie',
      main_label:     'Hoofdmenu',
      lang_label:     'Taal kiezen',
      login_aria:     'Inloggen op afgesloten omgeving',
      home_aria:      'Naar de startpagina',

      /* Aanvragers-dropdown */
      contractors:        'Aannemers',
      contractors_sub:    'Tijdelijke bouwstroom voor projecten',
      events:             'Evenementen',
      events_sub:         'Festivals, markten, sport',
      film:               'Filmorganisaties',
      film_sub:           'Productiestroom op locatie',

      /* Eigenaren-dropdown */
      government:         'Overheidsorganisaties',
      government_sub:     'Gemeenten, provincies, netbeheerders',
      businesses:         'Bedrijven',
      businesses_sub:     'Vastgoed, ketenpartners, leveranciers',
      register_connection: 'Aansluiting aanmelden',
      register_sub:       'Direct toevoegen aan de kaart',

      /* Types-dropdown */
      event_connections:  'Evenementen-aansluitingen',
      event_connections_sub: 'Vaste punten op evenementenlocaties',
      ev_charging:        'Openbare laadpalen',
      ev_charging_sub:    'EV-infra voor licht materieel',
      indirect:           'Indirecte stroompunten',
      indirect_sub:       'Met kleine aanpassing geschikt te maken',
    },

    footer: {
      tagline:       'De marktplaats voor passende stroomvoorzieningen.',
      tagline_long:  'Eén kaart voor heel Nederland.<br/>Stroom waar je het nodig hebt.',
      tag_full:      'Eén kaart voor alle type aansluitingen.<br/>Stroom waar je het nodig hebt.',
      product:       'Product',
      using:         'Gebruiken',
      use:           'Aanvragers',
      forwhom:       'Voor wie',
      types:         'Type stroomvoorzieningen',
      company:       'Bedrijf',
      open_map:      'Open de kaart',
      register:      'Aansluiting aanmelden',
      request_point: 'Een punt aanvragen',
      after_request: 'Na de aanvraag',
      municipalities: 'Gemeenten',
      login:         'Inloggen',
      contact:       'Contact',
      about:         'Over Stroomkaart',
      privacy:       'Privacy',
      terms:         'Algemene voorwaarden',
      disclaimer:    'Disclaimer',
      cookies:       'Cookies',
      copyright:     '© Stroomkaart',
      copyright_full: '© <span id="year">2026</span> Stroomkaart - een initiatief van NRG Group. Alle rechten voorbehouden.',
      copyright_tail: 'Stroomkaart - een initiatief van NRG Group. Alle rechten voorbehouden.',
      tagline_short: 'Een initiatief van NRG Group.',
    },

    cta_strip: {
      title_default:    'Klaar om je aansluiting te vinden?',
      sub_default:      'Doorzoek alle beschikbare stroompunten op de kaart, of meld er een aan als je er zelf één beheert.',
      sub_no_account:   'Geen account nodig om te bekijken wat beschikbaar is.',
      btn_open_map:     'Open de kaart',
      btn_register:     'Meld een aansluiting aan',
    },
    register_point:     'Stroompunt aanmelden',
    request_action:     'Aanvraag doen',
    submit_request:     'Verzend aanvraag →',
    request_received:   'Aanvraag ontvangen.',
    yes:                'Ja',
    no:                 'Nee',
    // Client-friendly fallbacks for failed submits (see friendlyError.ts).
    errors: {
      network: 'We konden de server niet bereiken. Controleer je internetverbinding en probeer het opnieuw.',
      invalid: 'Sommige gegevens ontbreken of zijn onjuist. Controleer het formulier en probeer het opnieuw.',
      generic: 'Er ging iets mis. Probeer het later opnieuw.',
    },
    btn: {
      cancel:   'Annuleren',
      close:    'Sluiten',
      save:     'Opslaan',
      submit:   'Verzenden',
      done:     'Klaar',
      back:     'Terug',
    },
    form: {
      name:           'Naam',
      email:          'E-mailadres',
      phone:          'Telefoon',
      organisation:   'Bedrijfsnaam',
      start_date:     'Startdatum',
      end_date:       'Einddatum',
      start_at:       'Startdatum',
      end_at:         'Einddatum',
      period:         'Periode',
      connector:      'Aansluiter',
      connector_name: 'Naam aansluiter',
      connector_phone: 'Telefoon aansluiter (optioneel)',
    },

    lang_switcher: {
      label: 'Taal',
      nl:    'NL',
      en:    'EN',
    },
  },
};

export const en = {
  common: {
    nav: {
      requesters:     'For Applicants',
      owners:         'For owners',
      types:          'Types of power supply',
      about_contact:  'About & Contact',
      login:          'Log in',
      open_map:       'Open the map',
      contact_cta:    'Get in touch',
      menu_open:      'Open menu',
      mobile_label:   'Mobile navigation',
      main_label:     'Main menu',
      lang_label:     'Choose language',
      login_aria:     'Log in to the secure area',
      home_aria:      'Back to home page',

      contractors:        'Contractors',
      contractors_sub:    'Temporary construction power for projects',
      events:             'Events',
      events_sub:         'Festivals, markets, sports',
      film:               'Film productions',
      film_sub:           'On-location production power',

      government:         'Government & public sector',
      government_sub:     'Municipalities, provinces, grid operators',
      businesses:         'Businesses',
      businesses_sub:     'Real estate, supply-chain partners, suppliers',
      register_connection: 'Register a connection',
      register_sub:       'Add directly to the map',

      event_connections:  'Event connections',
      event_connections_sub: 'Fixed points at event venues',
      ev_charging:        'Public EV chargers',
      ev_charging_sub:    'EV infrastructure for light equipment',
      indirect:           'Indirect power points',
      indirect_sub:       'Available with a small adjustment',
    },

    footer: {
      tagline:       'The marketplace for the right power supply.',
      tagline_long:  'One map for the whole country.<br/>Power where you need it.',
      tag_full:      'One map for all types of connections.<br/>Power where you need it.',
      product:       'Product',
      using:         'Use',
      use:           'Requesters',
      forwhom:       'For whom',
      types:         'Types of power supply',
      company:       'Company',
      open_map:      'Open the map',
      register:      'Register a connection',
      request_point: 'Request a connection',
      after_request: 'After the request',
      municipalities: 'Municipalities',
      login:         'Log in',
      contact:       'Contact',
      about:         'About Stroomkaart',
      privacy:       'Privacy',
      terms:         'Terms & conditions',
      disclaimer:    'Disclaimer',
      cookies:       'Cookies',
      copyright:     '© Stroomkaart',
      copyright_full: '© <span id="year">2026</span> Stroomkaart - an initiative of NRG Group. All rights reserved.',
      copyright_tail: 'Stroomkaart - an initiative of NRG Group. All rights reserved.',
      tagline_short: 'An initiative of NRG Group.',
    },

    cta_strip: {
      title_default:    'Ready to find your connection?',
      sub_default:      'Browse all available power points on the map, or register one if you manage one yourself.',
      sub_no_account:   'No account needed to browse what\'s available.',
      btn_open_map:     'Open the map',
      btn_register:     'Register a connection',
    },
    register_point:     'Register a power point',
    request_action:     'Submit a request',
    submit_request:     'Send request →',
    request_received:   'Request received.',
    yes:                'Yes',
    no:                 'No',
    // Client-friendly fallbacks for failed submits (see friendlyError.ts).
    errors: {
      network: 'We couldn\'t reach the server. Check your internet connection and try again.',
      invalid: 'Some details are missing or invalid. Please check the form and try again.',
      generic: 'Something went wrong. Please try again later.',
    },
    btn: {
      cancel:   'Cancel',
      close:    'Close',
      save:     'Save',
      submit:   'Submit',
      done:     'Done',
      back:     'Back',
    },
    form: {
      name:           'Name',
      email:          'Email',
      phone:          'Phone',
      organisation:   'Organisation',
      start_date:     'Start date',
      end_date:       'End date',
      start_at:       'Start date',
      end_at:         'End date',
      period:         'Period',
      connector:      'Connector',
      connector_name: 'Connector name',
      connector_phone: 'Connector phone (optional)',
    },

    lang_switcher: {
      label: 'Language',
      nl:    'NL',
      en:    'EN',
    },
  },
};
